import type { Except } from "type-fest";
import { z } from "zod";
import { generateId } from "../../utilities/generate-id";
import { idZodSchema } from "../id";
import type { Password} from "../password";
import { passwordZodSchema } from "../password";
import type { PhoneNumber} from "../phone";
import { phoneNumberZodSchema } from "../phone";
import type {
    InvitationId} from "../users/invitations/invitation-id";
import {
    invitationIdZodSchema,
} from "../users/invitations/invitation-id";

const idPrefix = "signupdata__";

type SignUpData = {
    _id: string;
    _type: "SIGN_UP_DATA";
    signUpId: string;
    firstName: string;
    lastName: string;
    invitationId?: InvitationId;
    emailAddress: string;
    phoneNumber: PhoneNumber;
    password?: Password;
    tips: boolean;
};

type FactoryParams = Except<SignUpData, "_id" | "_type"> & {
    _id?: string;
};

const signUpDataFactory = (params: FactoryParams): SignUpData => {
    return {
        ...params,
        _id: params._id || generateId({ prefix: idPrefix }),
        _type: "SIGN_UP_DATA",
    };
};

const emptySignUpData = (initialData?: Partial<SignUpData>): SignUpData => {
    return {
        firstName: "",
        lastName: "",
        emailAddress: "",
        phoneNumber: "" as PhoneNumber,
        password: undefined,
        signUpId: "",
        ...(initialData ?? {}),
        _id: generateId({ prefix: idPrefix }),
        _type: "SIGN_UP_DATA",
        tips: false,
    };
};

const signUpDataZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("SIGN_UP_DATA"),
    firstName: z.string(),
    lastName: z.string(),
    invitationId: invitationIdZodSchema.optional(),
    emailAddress: z.string().email(),
    phoneNumber: phoneNumberZodSchema,
    password: passwordZodSchema.optional(),
    signUpId: z.string(),
    tips: z.boolean(),
});

export {
    signUpDataFactory as createSignUpData,
    emptySignUpData,
    signUpDataZodSchema,
};
export type { SignUpData };
